"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _Input = _interopRequireDefault(require("../Input"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _featureDetect = require("../../utils/feature-detect");

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

var _Option = _interopRequireDefault(require("./Option"));

var _AriaClickHandler = _interopRequireDefault(require("../AriaClickHandler"));

var _utils = require("./utils");

var _SelectStyles = require("./SelectStyles");

var _core = require("@emotion/core");

var MIN_SEARCH_LENGTH = 0;

var Select =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Select, _React$PureComponent);

  function Select() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isOpen: false,
      inputText: _this.props.defaultSelectedText || '',
      selected: {
        dKey: _this.props.defaultSelectedKey || '',
        text: _this.props.defaultSelectedText || '',
        itemIndex: -1
      },
      selectedIndex: -1
    };
    _this.isTouchSupport = (0, _featureDetect.touchevents)();
    _this.optionIds = [];

    _this.setDefaultOption = function (option) {
      _this.defaultOption = option;
    };

    _this.handleSelected = function (e, option) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          textDisplayTransform = _this$props.textDisplayTransform;

      if (option) {
        _this.setState({
          selected: option,
          inputText: textDisplayTransform ? textDisplayTransform(option.text) : option.text,
          isOpen: false,
          selectedIndex: -1
        });

        e.stopPropagation();
      }

      if (onSelect) {
        onSelect(option);
      }
    };

    _this.toggleDropdown = function (state) {
      _this.setState({
        isOpen: state
      });

      if (state) {
        _this.input.focus();
      }
    };

    _this.handleOnChange = function (e) {
      var text = e.target.value;

      _this.setState({
        inputText: text
      });

      if (!text) {
        _this.removeSelection();
      } else {
        if (text.length >= (_this.props.minSearchLength || MIN_SEARCH_LENGTH)) {
          _this.toggleDropdown(true);
        } else {
          _this.toggleDropdown(false);
        }
      }

      if (_this.props.onInputChange) {
        _this.props.onInputChange(text);
      }
    };

    _this.handleInputKeyPress = function (e) {
      switch (e.keyCode) {
        // key up
        case 38:
          {
            e.preventDefault();

            if (_this.state.selectedIndex > 0) {
              var index = _this.state.selectedIndex - 1;

              _this.setState({
                selectedIndex: index
              });
            }

            break;
          }
        // key down

        case 40:
          {
            e.preventDefault();
            var nextIndex = _this.state.selectedIndex + 1;

            if (nextIndex < _this.childrenCount) {
              _this.setState({
                isOpen: true,
                selectedIndex: nextIndex
              });
            }

            break;
          }
        // escape

        case 27:
          {
            e.preventDefault();

            if (_this.state.isOpen) {
              if (!_this.props.isCombobox) {
                _this.setState({
                  inputText: ''
                });

                _this.input.focus();
              }

              _this.toggleDropdown(false);
            }

            break;
          }
        // enter key

        case 13:
          {
            e.preventDefault();

            if (_this.childrenCount < 1 && !_this.state.inputText || _this.props.filter === false && !_this.state.inputText) {
              _this.handleSelected(e, undefined);
            } else {
              _this.handleSelected(e, _this.defaultOption);
            }

            break;
          }

        case 9:
          {
            _this.toggleDropdown(false);

            break;
          }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.setInputContainerRef = function (element) {
      _this.inputDiv = element;
    };

    _this.setInputRef = function (element) {
      _this.input = element;
    };

    _this.setSelectedIndex = function (index) {
      _this.setState({
        selectedIndex: index
      });
    };

    _this.removeSelection = function () {
      _this.setState({
        selected: {}
      });
    };

    _this.handleResetInputText = function () {
      _this.setState({
        inputText: '',
        selected: {},
        selectedIndex: -1
      });

      if (_this.props.onResetInput) {
        _this.props.onResetInput();
      }

      _this.input.focus();
    };

    _this.handleOnFocus = function () {
      if (_this.props.onInputFocus) {
        _this.props.onInputFocus(_this.input);
      }
    };

    _this.handleOnBlur = function () {
      if (_this.props.onInputBlur) {
        _this.props.onInputBlur(_this.state.inputText);
      }
    };

    _this.handleClickOutside = function (e) {
      var target = e.target;

      if (_this.state.isOpen && _this.inputDiv && !_this.inputDiv.contains(target) && _this.dropdownUl && !_this.dropdownUl.contains(target)) {
        _this.toggleDropdown(false);
      }
    };

    _this.handleOnClick = function () {
      _this.toggleDropdown(true);
    };

    _this._getIcon = function (color, icon, isCombobox) {
      if (!isCombobox) {
        if (_this.props.isLoading) {
          return (0, _core.jsx)(_Loading.default, {
            size: "xxsmall"
          });
        }

        if (_this.state.inputText) {
          return (0, _core.jsx)(_AriaClickHandler.default, {
            css: _SelectStyles.selectButtonStyle,
            onClick: _this.handleResetInputText,
            "aria-label": _this.props.buttonAriaLabelClear
          }, (0, _core.jsx)(_Icon.default, {
            name: "cross",
            color: color,
            size: "small"
          }));
        } else {
          return icon ? (0, _core.jsx)(_Icon.default, {
            name: icon,
            size: "small",
            color: color
          }) : null;
        }
      } else {
        if (_this.state.isOpen) {
          return (0, _core.jsx)(_AriaClickHandler.default, {
            css: _SelectStyles.selectButtonStyle,
            onClick: function onClick() {
              return _this.toggleDropdown(false);
            },
            "aria-label": _this.props.buttonAriaLabelUpArrow
          }, (0, _core.jsx)(_Icon.default, {
            name: "carat_up",
            size: "xsmall",
            color: color
          }));
        } else {
          return (0, _core.jsx)(_AriaClickHandler.default, {
            css: _SelectStyles.selectButtonStyle,
            onClick: function onClick() {
              return _this.toggleDropdown(true);
            },
            "aria-label": _this.props.buttonAriaLabelDownArrow
          }, (0, _core.jsx)(_Icon.default, {
            name: "carat_down",
            size: "xsmall",
            color: color
          }));
        }
      }
    };

    _this._getChildrenWithInjectedProps = function (children) {
      var childrenWithNewProps = [];
      var itemIndex = 0;

      if (_this.state.inputText.length < (_this.props.minSearchLength || MIN_SEARCH_LENGTH)) {
        return childrenWithNewProps;
      } // const setSize = React.Children.count(children);


      _react.default.Children.forEach(children, function (child, index) {
        var optionKey = child.props.dKey || child.props.value;
        var isSelected = _this.props.comparator ? _this.props.comparator(child.props.itemData) : _this.state.selected.dKey === optionKey;
        var id = "".concat(_this.props.id, "_option_").concat(index);
        _this.optionIds[index] = id;
        var newProps = {
          'aria-posinset': index + 1,
          'aria-selected': isSelected,
          //index === this.state.selectedIndex,
          ariaLabelSelected: _this.props.ariaLabelSelected,
          id: id,
          dKey: optionKey,
          isSelected: isSelected,
          itemIndex: 0,
          selectedIndex: _this.state.selectedIndex,
          onSelect: _this.handleSelected,
          role: 'option',
          setDefaultOption: _this.setDefaultOption,
          setSelectedIndex: _this.setSelectedIndex,
          tabIndex: -1
        };

        if (_this.state.inputText.trim() === '' || _this.props.isCombobox || _this.props.filter === false) {
          newProps.itemIndex = itemIndex;
          itemIndex++;
          childrenWithNewProps.push(_react.default.cloneElement(child, newProps));
        } else {
          if (typeof _this.props.filter === 'boolean' && _this.props.filter === true) {
            // use defualt filter
            var shouldInclude = (0, _utils.defaultFilter)(_this.state.inputText.toString(), child.props);

            if (shouldInclude) {
              newProps.itemIndex = itemIndex;
              itemIndex++;
              childrenWithNewProps.push(_react.default.cloneElement(child, newProps));
            }
          }

          if (typeof _this.props.filter === 'function') {
            // use provided filter
            var _shouldInclude = _this.props.filter(_this.state.inputText.toString(), child.props);

            if (_shouldInclude) {
              newProps.itemIndex = itemIndex;
              itemIndex++;
              childrenWithNewProps.push(_react.default.cloneElement(child, newProps));
            }
          }
        }
      });

      return childrenWithNewProps;
    };

    _this.renderInput = function (hasError, shouldOpen) {
      var _this$props2 = _this.props,
          error = _this$props2.error,
          id = _this$props2.id,
          inputClassName = _this$props2.inputClassName,
          isCombobox = _this$props2.isCombobox,
          name = _this$props2.name,
          noIcon = _this$props2.noIcon,
          placeholder = _this$props2.placeholder;
      var inputProps = {
        'aria-describedby': _this.props['aria-describedby'],
        'aria-activedescendant': _this.optionIds[_this.state.selectedIndex],
        'aria-autocomplete': !isCombobox ? 'list' : undefined,
        'aria-expanded': shouldOpen,
        'aria-invalid': error,
        'aria-owns': "".concat(id, "_owned_listbox"),
        autoComplete: 'off',
        className: inputClassName,
        hasError: hasError,
        id: id,
        innerRef: _this.setInputRef,
        name: name,
        onBlur: _this.handleOnBlur,
        onChange: _this.handleOnChange,
        onClick: _this.handleOnClick,
        onFocus: _this.handleOnFocus,
        onKeyDown: _this.handleInputKeyPress,
        placeholder: placeholder,
        readOnly: isCombobox,
        role: 'combobox',
        style: {
          width: '100%',
          paddingRight: noIcon ? 'inherit' : '48px'
        },
        value: _this.state.inputText
      };

      if (_this.props.inputElement && _react.default.isValidElement(_this.props.inputElement)) {
        var customInput = _react.default.cloneElement(_this.props.inputElement, inputProps);

        return customInput;
      }

      if (_this.props.buildInputElement) {
        return _this.props.buildInputElement(inputProps);
      }

      var defaultInput = (0, _core.jsx)(_Input.default, inputProps);
      return defaultInput;
    };

    return _this;
  }

  (0, _createClass2.default)(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside);

      if (this.isTouchSupport) {
        document.addEventListener('touchstart', this.handleClickOutside);
      }

      if (this.input && this.props.autofocus) {
        this.input.focus();
      }

      if (this.props.getInputRef) {
        this.props.getInputRef(this.input); // this should be deprecated in the future in favor of innerRef
      }

      if (this.props.innerRef) {
        this.props.innerRef(this.input);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);

      if (this.isTouchSupport) {
        document.removeEventListener('touchstart', this.handleClickOutside);
      }
    }
  }, {
    key: "shouldOpenDropdown",
    value: function shouldOpenDropdown(newChildren) {
      if (this.props.filter === false && !this.props.isCombobox) {
        // for filter disabled mode, only show when nothing found
        return this.state.isOpen && this.state.inputText.trim() !== '' && (newChildren.length > 0 || this.props.error);
      } else {
        return this.state.isOpen && (newChildren.length > 0 || this.state.inputText.trim() !== '') && !this.props.isLoading;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          alignRight = _this$props3.alignRight,
          children = _this$props3.children,
          dropdownClassName = _this$props3.dropdownClassName,
          error = _this$props3.error,
          icon = _this$props3.icon,
          iconColor = _this$props3.iconColor,
          id = _this$props3.id,
          isCombobox = _this$props3.isCombobox,
          noIcon = _this$props3.noIcon,
          noResult = _this$props3.noResult;

      var newChildren = this._getChildrenWithInjectedProps(children);

      this.childrenCount = newChildren.length;
      var shouldOpen = this.shouldOpenDropdown(newChildren) || false;
      var hasError = !!error && (!shouldOpen || this.childrenCount === 0);
      return (0, _core.jsx)(_SelectStyles.SelectContainer, {
        "data-uia-select": this.props['data-uia-select']
      }, (0, _core.jsx)("div", {
        css: _SelectStyles.inputContainerStyle,
        ref: this.setInputContainerRef
      }, this.renderInput(hasError, shouldOpen), !noIcon && (0, _core.jsx)(_SelectStyles.IconContainer, null, this._getIcon(iconColor, icon, isCombobox))), (0, _core.jsx)(_Dropdown.default, {
        alignRight: alignRight,
        className: dropdownClassName,
        id: id,
        innerRef: function innerRef(el) {
          return _this2.dropdownUl = el;
        },
        isOpen: shouldOpen,
        noResult: noResult
      }, newChildren));
    }
  }]);
  return Select;
}(_react.default.PureComponent);

Select.Option = _Option.default;
var _default = Select;
exports.default = _default;